define('models/Eft',[
	'models/Base',
	'models/Session',
	'highcharts',
	'moment'
], function(Base, Session, Highcharts, moment) {
	
	function map(check) {
		return {
			// name: check.attr('_ProviderName'),
			x: check.attr('_Date'),
			y: check.attr('Amount')
		}
	}
	
	var Check = Base.extend({

		findAll: 'GET /Check/List',
		findOne: 'GET /Check/{id}',
				
		// Report includes projected values
		findAllWithProjected: function(params, success, error) {
			return can.ajax({
					type: 'GET',
					url: '/Report/Eft',
					data: params
				})
				.then(can.proxy(this.models, this))
				.then(success, error);
		},
		
		chartOptions: function() {
			return {
				chart: {
					height: 300,
					type: 'column',
					backgroundColor: 'transparent' // rgba(255, 255, 255, 0.1) IE8
				},
				title: {
					text: null
				},
				plotOptions: {
					column: {
						stacking: 'normal'
					},
					series: {
		                dataLabels: {
		                    enabled: false
		                },
						states: {
							hover: {
								enabled: true,
								lineWidth: 0,
								lineWidthPlus: 0
							}
						},
						point: {
		                    events: {
		                    }
		                }
					}
				},
				tooltip: {

					headerFormat: "",

					pointFormatter: function() {
						if(this.tooltipHeader) {
							return can.sub('{tooltipHeader} <br/> {series}: <b>{amount}</b>', {
								series: this.series.name,
								amount: '$' + this.y.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"),
								tooltipHeader: this.tooltipHeader
							})
						}
						else {
							return can.sub('{series}: <b>{amount}</b>', {
								series: this.series.name,
								amount: '$' + this.y.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
							})
						}						
					}
				},
				xAxis: {
					type: 'datetime',
					plotBands: [{
						color: '#ffffea',
						from: +moment.utc().startOf('d'),
						to: Date.UTC(3000, 0, 0),
						borderWidth: 1,
						borderColor: '#f5f5d3'
					}],
					minTickInterval: 24 * 60 * 60 * 1000
				},
				yAxis: {
					min: 0,
					title: {
						text: 'Amount'
					},
					stackLabels: {
						enabled: true,
	                    style: {
							fontWeight: 'bold',
							color: 'black'
						},
						formatter: function() {
							return (this.total === null) ? '' : '$' + this.total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
						}
					}
				},
				credits: {
					enabled: false
				}
			}
		}
		
	},{

		_ProviderName: can.compute(function() {
			var p = Session.attr('Providers').findById(this.attr('ProviderId'));
			return p === undefined ? undefined : p.attr('Name');
		}),
		
		_ProviderNpi: can.compute(function() {
			var p = Session.attr('Providers').findById(this.attr('ProviderId'));
			return p === undefined ? undefined : p.attr('Npi');
		}),
		
		_Date: can.compute(function() {
			return +moment.utc(this.attr('Date')).startOf('d');
		})
		
	});
	
	var colors = Highcharts.getOptions().colors;
	
	Check.List = Check.List.extend({
		
		comparator: 'Date',
		
		seriesDataByProvider: function() {
			
			var hash = {}, series = [];
			
			for (var i=0; i<this.attr('length'); i++) {
				var check = this.attr(i);
				
				if (hash[check.attr('ProviderId')] === undefined) {
					hash[check.attr('ProviderId')] = {
						id: check.attr('ProviderId'),
						name: check.attr('_ProviderName'),
						data: []
					};
					series.push(hash[check.attr('ProviderId')]);
				}
				
				hash[check.ProviderId].data.push({
					id: i,
					x: Date.parse(check.attr('Date')),
					y: check.attr('Amount')
				});
			}
			
			return series;
		},
		
		seriesDataByProjected: function() {
			
			var paid = [], 
				paidhash = {},
				projected = [],
				projectedhash = {};
			
			this.each( function(c) {
				var isPaid = !!c.attr('Number'),
					hash = isPaid ? paidhash : projectedhash,
					array = isPaid ? paid : projected,
					x = c.attr('_Date');
				if (hash[x]) {
					hash[x].y += c.attr('Amount');
				} else {
					hash[x] = map(c)
					array.push(hash[x]);
				}
			});
			
			return [{
				name: 'Projected',
				data: projected,
				color: colors[0],	
				legendIndex: 1
			},{
				name: 'Paid',
				data: paid,
				color: colors[1],
				legendIndex: 0
			}]
		}
	})
	
	return Check;
	
});
